import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const InviteeOrientationBoardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InviteeOrientationBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"shortLink"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberType"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"InviteeOrientationBoard","document":InviteeOrientationBoardDocument}} as const;
export type InviteeOrientationBoardQueryVariables = Types.Exact<{
  boardId: Types.Scalars['ID'];
}>;


export type InviteeOrientationBoardQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id' | 'idOrganization' | 'shortLink'>
    & { members: Array<(
      { __typename: 'Member' }
      & Pick<Types.Member, 'id' | 'memberType'>
    )> }
  )> }
);

/**
 * __useInviteeOrientationBoardQuery__
 *
 * To run a query within a React component, call `useInviteeOrientationBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteeOrientationBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteeOrientationBoardQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useInviteeOrientationBoardQuery(
  baseOptions: TrelloQueryHookOptions<
    InviteeOrientationBoardQuery,
    InviteeOrientationBoardQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: InviteeOrientationBoardDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    InviteeOrientationBoardQuery,
    InviteeOrientationBoardQueryVariables
  >(InviteeOrientationBoardDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useInviteeOrientationBoardLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    InviteeOrientationBoardQuery,
    InviteeOrientationBoardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InviteeOrientationBoardQuery,
    InviteeOrientationBoardQueryVariables
  >(InviteeOrientationBoardDocument, options);
}
export type InviteeOrientationBoardQueryHookResult = ReturnType<
  typeof useInviteeOrientationBoardQuery
>;
export type InviteeOrientationBoardLazyQueryHookResult = ReturnType<
  typeof useInviteeOrientationBoardLazyQuery
>;
export type InviteeOrientationBoardQueryResult = Apollo.QueryResult<
  InviteeOrientationBoardQuery,
  InviteeOrientationBoardQueryVariables
>;
